import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PersonStammMasterDetailEntryMeta } from '../../../../core/personstamm-api';
import { KopfdatenelementComponent } from '../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { FormatUidPipe } from '../../../../shared/pipes/format/format-uid.pipe';
import { TranslateNamePipe } from '../../../../shared/pipes/simple/translate-name.pipe';

@Component({
  selector: 'cap-personstamm-oeffentl-rechtl-koerperschaft',
  templateUrl: './personstamm-oeffentl-rechtl-koerperschaft.component.html',
  styleUrls: ['./personstamm-oeffentl-rechtl-koerperschaft.component.scss'],
  imports: [KopfdatenelementComponent, TranslatePipe, FormatUidPipe, TranslateNamePipe]
})
export class PersonstammOeffentlRechtlKoerperschaftComponent implements OnInit {
  @Input()
  public entry: PersonStammMasterDetailEntryMeta;

  constructor(public translate: TranslateService) {}

  ngOnInit() {}
}
